module.exports = {"140404100":"韩店镇","140404101":"苏店镇","140404102":"荫城镇","140404103":"西火镇","140404104":"八义镇","140404105":"贾掌镇","140404200":"郝家庄乡","140404201":"西池乡","140404202":"北呈乡","140404203":"东和乡","140404204":"南宋乡","140404400":"振兴新区","140404401":"上党经济技术开发区","140404406":"长治市经济技术开发区长治县部分","140404407":"信义管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140404.json
// module id = 292
// module chunks = 0